// Generated by purs version 0.15.0
import * as $foreign from "./foreign.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Nullable from "../Data.Nullable/index.js";
import * as Effect from "../Effect/index.js";
import * as Unsafe_Coerce from "../Unsafe.Coerce/index.js";
import * as Web_Internal_FFI from "../Web.Internal.FFI/index.js";
var toParentNode = Unsafe_Coerce.unsafeCoerce;
var toNonElementParentNode = Unsafe_Coerce.unsafeCoerce;
var toNode = Unsafe_Coerce.unsafeCoerce;
var toEventTarget = Unsafe_Coerce.unsafeCoerce;
var getElementsByTagNameNS = function ($0) {
    return $foreign["_getElementsByTagNameNS"](Data_Nullable.toNullable($0));
};
var fromParentNode = /* #__PURE__ */ Web_Internal_FFI.unsafeReadProtoTagged("Document");
var fromNonElementParentNode = /* #__PURE__ */ Web_Internal_FFI.unsafeReadProtoTagged("Document");
var fromNode = /* #__PURE__ */ Web_Internal_FFI.unsafeReadProtoTagged("Document");
var fromEventTarget = /* #__PURE__ */ Web_Internal_FFI.unsafeReadProtoTagged("Document");
var documentElement = /* #__PURE__ */ (function () {
    var $1 = Data_Functor.map(Effect.functorEffect)(Data_Nullable.toMaybe);
    return function ($2) {
        return $1($foreign["_documentElement"]($2));
    };
})();
var doctype = function ($3) {
    return Data_Nullable.toMaybe($foreign["_doctype"]($3));
};
var createElementNS = function ($4) {
    return $foreign["_createElementNS"](Data_Nullable.toNullable($4));
};
export {
    url,
    documentURI,
    origin,
    compatMode,
    characterSet,
    contentType,
    getElementsByTagName,
    getElementsByClassName,
    createElement,
    createDocumentFragment,
    createTextNode,
    createComment,
    createProcessingInstruction,
    importNode,
    adoptNode
} from "./foreign.js";
export {
    fromNode,
    fromParentNode,
    fromNonElementParentNode,
    fromEventTarget,
    toNode,
    toParentNode,
    toNonElementParentNode,
    toEventTarget,
    doctype,
    documentElement,
    getElementsByTagNameNS,
    createElementNS
};
//# sourceMappingURL=index.js.map
